var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavClick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25988 1.4992H4.23535C4.23535 1.4992 4.24388 1.49881 4.25988 1.4992ZM4.25988 1.4992H16.2727C17.6196 1.4992 18.7115 2.51968 18.7115 4.01582V13.0509M4.25988 1.4992C4.50283 1.50509 6.46916 1.6899 6.46916 6.12957V12.3425C6.46916 13.6258 8.2698 14.2481 9.2789 13.3136L10.7252 12.211M12.9927 16.0983L12.9939 13.0654M12.9939 13.0654L12.994 13.0483M12.9939 13.0654C12.9939 13.0597 12.9939 13.054 12.994 13.0483M15.2509 13.8612L15.2497 13.0655C15.2497 11.4156 13.0081 11.4099 12.994 13.0483M15.2509 13.8612V16.0983M15.2509 13.8612C15.2494 12.1285 17.5067 12.1292 17.5067 13.8612L17.5079 14.7991M17.5079 14.7991L17.5067 16.0983M17.5079 14.7991C17.5064 13.0664 19.7637 13.0672 19.7637 14.7991L19.7636 18.4309C19.7635 20.6788 17.9413 22.501 15.6935 22.501H10.7503C10.7503 22.501 6.89631 17.4983 6.53484 16.9946C5.99264 16.2389 6.22031 15.3849 7.57722 15.3849C8.9341 15.3849 9.71664 16.9394 10.7503 16.9394C10.7564 16.9409 10.7568 14.829 10.7515 9.61229C10.75 7.94497 13.0073 7.94579 13.0073 9.61234L12.994 13.0483",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavClick);
export default __webpack_public_path__ + "static/media/fav_click.f4786ac4c41634ff624bd0e8f07411d0.svg";
export { ForwardRef as ReactComponent };